export default {"src":"/_next/static/media/searching_bottom_banner.475318d9.svg","height":76,"width":852,"blurWidth":0,"blurHeight":0};